import { render, staticRenderFns } from "./FilterChat.vue?vue&type=template&id=d5bca0ac&scoped=true"
import script from "./FilterChat.vue?vue&type=script&lang=js"
export * from "./FilterChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bca0ac",
  null
  
)

export default component.exports